import React from "react";
import "./ClaimsStatus.css";
import hand from "../../assets/img/claims/hand_blue.svg";

import covered_layout from "../../assets/img/claims/covered_layout.svg";
import card_header from "../../assets/img/claims/car_header_b.svg";
import checkIcon from "../../assets/img/aboutus/check.svg";
import { Container, Row, Col, Image, Card, Badge } from "react-bootstrap";

const ClaimsStatus = ({ responsiveStatus }) => {
  const claimOptions = [
    {
      icon: hand,
      title: "Policy Holders",
      description: (
        <>
          If you have a policy with United Auto, you can now use our newly
          launched digital claims portal to file claims and track status updates
          24/7 from any device.
        </>
      ),
      buttonText: "Start Here",
      url: "https://myclaim.uaig.net",
    },
    {
      icon: hand,
      title: "Non-Policy Holders",
      description: (
        <>
          All parties can use our inquiry portal to check claim status, or
          submit claim inquiries, and/or documents to adjuster handling your
          claim. It is available 24/7.
        </>
      ),
      buttonText: "Start Here",
      url: "https://account-management-claims-uaic-gwcpprod-prod.delta4-andromeda.guidewire.net/account-management-claims/tpp-claims",
    },
  ];

  return (
    <>
      <div className="" style={styles.container}>
        <Row
          className="align-items-center rowStatus"
          style={{ position: "relative", left: 0, marginLeft: "0px" }}
        >
          {/* Left Column: Text Content */}
          <Col lg={8}>
            <p
              style={{
                color: "#17252E",
                fontSize: "16px",
                lineHeight: "140%",
                fontWeight: 600,
                whiteSpace: "nowrap",
                position: "relative", // required for ::after
                display: "inline-block",
              }}
            >
              <span
                style={{
                  position: "relative",
                  paddingBottom: "5px",
                }}
              >
                Claim Status
                <span
                  style={{
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: -4,
                    height: "1.6px",
                    width: "100%", // Extend beyond text
                    backgroundColor: "#0e72d6",
                    transform: "translateX(0%)", // Centered extension
                  }}
                />
              </span>
            </p>

            <h2
              className="mt-2"
              style={{
                color: "#000",
                lineHeight: "100%",
                fontWeight: 600,
                fontSize: responsiveStatus ? "32px" : "32px",
                marginBottom: "0.5em",
              }}
            >
              What is the status of my claim?
            </h2>
            <p>
              Stay updated on your claim every step of the way! With our claims
              portal, you can easily check the status of your claim anytime,
              anywhere.
            </p>

            <div className="row g-2">
              {claimOptions.map((option, idx) => (
                <div
                  key={idx}
                  className="col-md-6 col-12"
                  style={{ paddingRight: "15px", paddingLeft: "15px" }}
                >
                  <div
                    className="card shadow-sm border-1"
                    style={{
                      width: "95%",
                      minHeight: "300px",
                      display: "inline-block",
                      maxWidth: "350px",
                    }}
                  >
                    <div
                      className="card-header d-block text-left"
                      style={styles.container2}
                    >
                      <div style={styles.backgroundOverlay}></div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          gap: "15px",
                        }}
                      >
                        <img
                          src={option.icon}
                          alt="icon"
                          style={{ height: 70, marginBottom: 16 }}
                        />
                        <p className="card-title fw-bold">{option.title}</p>
                      </div>
                    </div>

                    <div
                      className={`${
                        responsiveStatus
                          ? "card-body1 text-left"
                          : "card-body text-left"
                      }`}
                    >
                      <p
                        className={`${
                          responsiveStatus
                            ? "card-text1 text-left text-muted1 mt-2 ml-2"
                            : "card-text1 text-muted mt-2"
                        }`}
                      >
                        {option.description}
                      </p>
                    </div>
                    <div
                      className="card-footer text-left"
                      style={{ marginTop: "0px", marginLeft: "10px" }}
                    >
                      <a
                        href={option.url}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-style"
                        style={{ width: "105px", left: "10%" }}
                      >
                        {option.buttonText}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>

          {/* Right Column: Image + Floating Cards */}
          <Col lg={4} className="position-relative mt-5 mt-lg-0 text-center ">
            {/* Circular Image */}
            <div className="uaic -image-wrapper mx-auto">
              <img
                src={require("../../assets/img/claims/claimStatus_right.svg")}
                roundedCircle
                fluid
                className={`${
                  responsiveStatus === "isDesktop"
                    ? "aboutRightImage"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "hide"
                    : "aboutRightImage-m"
                }`}
                alt="claimStatus_right icon"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${covered_layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    maxWidth: "1350px",
    margin: "0 auto",
  },
  container2: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    // minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${card_header})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default ClaimsStatus;
